import { connect } from 'react-redux';
import DataSourceCard from './DataSourceCard';
import has from 'lodash/has';
import { isReadOnly, isManagedResource, isAdminAccess } from '../../../lib/ACLUtils';
import { getConnectionOrVendorType } from '../../../lib/ResourceUtils';

import { getDashboardMetricsForSource } from '../../../reducers/selectors';
import { RESOURCE_TYPE_SOURCE } from '../../../constants/resourceTypes';

const mapStateToProps = (state, ownProps) => {
  const {
    entities: { sources, users, vendors, flowNodes, credentials },
    paging: { metaInfoById },
    metrics,
    request,
  } = state;
  const { cardData } = ownProps;
  const entity = sources[cardData.id];
  const data = { ...cardData, ...entity };

  const flow = flowNodes[data.origin_node_id];
  const flowType = data?.flow_type || flow?.flow_type;

  const metric = has(metrics[RESOURCE_TYPE_SOURCE], cardData.id)
    ? metrics[RESOURCE_TYPE_SOURCE][cardData.id]
    : null;

  const connectionOrVendorType = getConnectionOrVendorType(
    data,
    vendors,
    'source_type',
    'vendor_id',
  );

  const connectionInfo =
    metaInfoById && has(metaInfoById, connectionOrVendorType)
      ? metaInfoById[connectionOrVendorType]
      : null;

  const readOnly = isReadOnly(data);
  const isManaged = isManagedResource(data);
  const adminAccess = isAdminAccess(data);
  const resourceMetrics = getDashboardMetricsForSource(state, ownProps);

  let owner = null;
  if (has(data, 'owner_id') && has(users, data.owner_id)) {
    owner = users[data.owner_id];
  } else if (has(data, 'owner') && has(users, data.owner)) {
    owner = users[data.owner];
  }

  return {
    flowType,
    credentials,
    connectionInfo,
    data,
    readOnly,
    adminAccess,
    isManaged,
    owner,
    connectionOrVendorType,
    metric,
    isLoading: {
      metric: request.GET_FLOW_METRICS_REQUEST || false,
    },
  };
};

export default connect(mapStateToProps)(DataSourceCard);
